import React from 'react';
import Profile from '../../components/Account/Profile';
import Canonical from '../../utils/Canonical';

const ProfilePage = () => {
  return (
    <>
      <Canonical path='/profile' title='Profile' />
      <div className='account-wrapper'>
        <h1>Profile</h1>
        <Profile />
      </div>
    </>
  );
};

export default ProfilePage;
